import { render } from "./TicketPurchaseComponent.vue?vue&type=template&id=a4598c16&scoped=true&ts=true"
import script from "./TicketPurchaseComponent.vue?vue&type=script&lang=ts"
export * from "./TicketPurchaseComponent.vue?vue&type=script&lang=ts"

import "./TicketPurchaseComponent.vue?vue&type=style&index=0&id=a4598c16&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4598c16"]])

export default __exports__